import { Button, message } from 'antd';
import React from 'react';
const copyToClipboard = async (text) => {
    if (text !== undefined) {
        await navigator.clipboard.writeText(text);
        message.success('Copied to clipboard');
    }
    else {
        message.warn('Could not copy to clipboard');
    }
};
export const ClipboardButton = (props) => {
    return (React.createElement(Button, { id: "clipboardCopy-btn", type: "default", shape: "round", onClick: () => copyToClipboard(props.copyText) }, props.buttonText));
};
